// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"187":"NotFound","443":"about","561":"ArticleShow"}[chunkId] + "." + {"187":"324821f5","443":"1a013d63","561":"46f0dd32"}[chunkId] + ".js";
};